//export const URI =  'http://localhost:5000/';

export const URI =  '/'; //droplet server

const API_URL = {

    'SERVER_PATH' : URI,

    POST_ATHLETE_RESET_PASSWORD : URI + 'api/athlete/reset-password/',
    VERIFY_SECURE_CODE : URI + 'api/athlete/verify-secure-code',


    /*EXERCISE LIBRARY API CALLS */
    'POST_CREATE_EXERCISE_FROM_ADMIN': URI + 'api/exercise_library/create',
    'GET_EXERCISE_LIBRARY_ADMIN': URI + 'api/exercise_library/all',
    'GET_EXERCISE_LIBRARY_LIST_ADMIN': URI + 'api/exercise_library/alllist',
    'DELETE_EXERCISE_LIBRARY_ADMIN': URI + 'api/exercise_library' ,
    'POST_EDIT_EXERCISE_FROM_ADMIN' : URI + 'api/exercise_library',
    'GET_EXERCISE_BY_ID_ADMIN' : URI + 'api/exercise_library',
    'GET_EXERCISE_LIBRARY_TYPES': URI + 'api/exercise_library/alltypes',

    /*SPEED TENMPLATE - WARMUP ROUTINE TEMPLATE CALLS */
    'ADMIN_POST_SPEED_TEMPLATE_WARMUP_ROUTINE_NEW': URI + 'api/template_speed/warmup_routine/createtemplate',
    'ADMIN_SPEED_TEMPLATE_WARMUP_ROUTINE_MANAGE': URI + 'api/template_speed/warmup_routine/getalltemplate',
    'ADMIN_DELETE_SPEED_TEMPLATE_WARMUP_ROUTINE_TEMPLATE': URI + 'api/template_speed/warmup_routine/deletetemplate/',
    'ADMIN_GET_SPEED_TEMPLATE_WARMUP_ROUTINE_TEMPLATE': URI + 'api/template_speed/warmup_routine/gettemplate/',
    'ADMIN_POST_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASEANDEXERCISES': URI + 'api/template_speed/warmup_routine/savetemplate/',
    'ADMIN_DELETE_SPEED_TEMPLATE_WARMUP_ROUTINE_EXERCISE' : URI + 'api/template_speed/warmup_routine/deletetemplateexercise/',
    'ADMIN_DELETE_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASE' : URI + 'api/template_speed/warmup_routine/deletetemplatephase/',
    'ADMIN_SAVE_SPEED_TEMPLATE_TITLE': URI + 'api/template_speed/warmup_routine/savetemplatetitle/',
    'ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_EXERCISE_DATA' : URI + 'api/template_speed/warmup_routine/saveexercisedata/',
    'ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASE_REST_DATA' : URI + 'api/template_speed/warmup_routine/savephaserest/',
    'ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASE_ADD_MORE_EX' : URI + 'api/template_speed/warmup_routine/phaseaddmoreexercise/' ,
    'ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_ALL_DATA' : URI + 'api/template_speed/warmup_routine/savealltemplatedata/' ,
    'ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_EXERCISES_ORDER' : URI + 'api/template_speed/warmup_routine/updateexercisesorder/',
    'ADMIN_SAVE_SPEED_TEMPLATE_WARMUP_ROUTINE_PHASE_TITLE': URI + 'api/template_speed/warmup_routine/updatephasetitle/' ,
    'ADMIN_GET_SPEED_TEMPLATE_WARMUP_ROUTINE_LIST' : URI + 'api/template_speed/warmup_routine/getwarmuptemplatelist',

    /*SPEED TEMPLATE - TRAINING FOCUS CALLS */
    'ADMIN_POST_SPEED_TEMPLATE_CREATE_TRAINING_FOCUS' : URI + 'api/template_speed/training_focus/createtrainingfocus',
    'ADMIN_SPEED_TEMPLATE_TRAINING_FOCUS_MANAGE' : URI + 'api/template_speed/training_focus/getalltrainingfocus',
    'ADMIN_SPEED_TEMPLATE_GET_TRAINING_FOCUS_LIST' : URI + 'api/template_speed/training_focus/getalltrainingfocuslist',
    'ADMIN_SPEED_TEMPLATE_GET_TRAINING_PHASE_LIST' : URI + 'api/template_speed/training_focus/getalltrainingphaselist',
    'ADMIN_DELETE_SPEED_TEMPLATE_TRAINING_FOCUS' : URI + 'api/template_speed/training_focus/deletetrainingfocus/',
    'ADMIN_GET_SPEED_TEMPLATE_TRAINING_FOCUS_TEMPLATE' : URI + 'api/template_speed/training_focus/gettrainingfocusdata/',
    'ADMIN_SAVE_SPEED_TEMPLATE_TRAINING_FOCUS_AND_TRAINING_PHASE' : URI + 'api/template_speed/training_focus/savetrainingfocusandtrainingphase/',
    'ADMIN_SAVE_SPEED_TEMPLATE_TRAINING_FOCUS_SPRINTS' : URI + 'api/template_speed/training_focus/savetrainingfocussprints/',
    'ADMIN_GET_SPEED_TEMPLATE_TRAINING_FOCUS_SPRINTS' : URI + 'api/template_speed/training_focus/gettrainingfocussprints/',
    'ADMIN_SAVE_SPEED_TEMPLATE_TRAINING_FOCUS_REST' : URI + 'api/template_speed/training_focus/savetrainingfocusrest/',

    /*SPEED TEMPLATE - TRAINING TEMPLATE CALLS */
    'ADMIN_CREATE_SPEED_TRAINING_TEMPLATE' : URI + 'api/template_speed/training_template/createtrainingtemplate',
    'ADMIN_MANAGE_SPEED_TRAINING_TEMPLATE' : URI + 'api/template_speed/training_template/managetrainingtemplate',
    'ADMIN_DELETE_SPEED_TRAINING_TEMPLATE' : URI + 'api/template_speed/training_template/deletetrainingtemplate/',
    'ADMIN_GET_SPEED_TRAINING_TEMPLATE' : URI + 'api/template_speed/training_template/gettrainingtemplate/',
    'ADMIN_UPDATE_SPEED_TRAINING_TEMPLATE' : URI + 'api/template_speed/training_template/edittrainingtemplate/',
    'ADMIN_SAVE_SPEED_TRAINING_TEMPLATE' : URI + 'api/template_speed/training_template/savetrainingtemplate/',
    'ADMIN_GET_SPEED_TRAINING_TEMPLATE_LIST' : URI + 'api/template_speed/training_template/gettrainingtemplatelist',


    /*SPEED TEMPLATE - PRODUCT CALLS */
    'ADMIN_CREATE_SPEED_PRODUCT' : URI + 'api/template_speed/product/createspeedproduct',
    'ADMIN_MANAGE_SPEED_PRODUCT' : URI + 'api/template_speed/product/managespeedproduct',
    'ADMIN_DELETE_SPEED_PRODUCT' : URI + 'api/template_speed/product/deletespeedproduct/',
    'ADMIN_EDIT_SPEED_PRODUCT' : URI + 'api/template_speed/product/editspeedproduct/',
    'FRONTEND_SPEED_ALL_PRODUCTS' : URI + 'api/template_speed/product/getallspeedproducts',
    'FRONTEND_SPEED_PRODUCT_DETAIL' : URI + 'api/template_speed/product/getspeedproductdetail/',

    'FRONTEND_ATHLETE_PURCHASED_SPEED_PRODUCTS' : URI + 'api/template_speed/product/getathletepurchasedspeedproducts/',
    'FRONTEND_ATHLETE_PURCHASED_SPEED_PRODUCT_DETAIL' : URI + 'api/template_speed/product/getathletepurchasedspeedproductdetail/',

    'FRONTEND_ATHLETE_COACHED_WARMUPROUTINE_PHASES' : URI + 'api/athlete/warmup_routine/getcoachedathletewarmuproutine/' ,


    // SPEED WARMUP ATHLETE CALLS /
    'SAVE_ATHLETE_WARMUP_ROUTINE': URI + 'api/athlete/warmup_routine/savewarmuproutine',
    'GET_ATHLETE_WARMUP_ROUTINE': URI + 'api/athlete/warmup_routine/getwarmuproutine/',
    'DELETE_ATHLETE_WARMUP_ROUTINE' : URI + 'api/athlete/warmup_routine/deletewarmuproutine/',

    //SPEED WORKOUT ATHLETE CALLS //
    'SAVE_ATHLETE_SPEEDWORKOUT_WEEK': URI + 'api/athlete/speedworkout/saveweekdata/',
    'GET_ATHLETE_SPEEDWORKOUT_WEEKS': URI + 'api/athlete/speedworkout/getweekdata/',
    'DELETE_ATHLETE_SPEEDWORKOUT_WEEK': URI + 'api/athlete/speedworkout/deleteweekdata',
    'SAVE_ATHLETE_SPEEDWORKOUT_DATA': URI + 'api/athlete/speedworkout/saveall',

    'FRONTEND_COACHED_ATHLETE_SPEED_WORKOUT' : URI + 'api/athlete/speedworkout/getcoachedathletespeedworkout/',

    'FRONTEND_COACHED_ATHLETE_SAVE_ACTUAL_TIME' : URI + 'api/athlete/speedworkout/saveathleteactualtime/',
    'FRONTEND_COACHED_ATHLETE_SAVE_VIDEO' : URI + 'api/athlete/speedworkout/uploadathletevideo/',
    'FRONTEND_COACHED_ATHLETE_GET_VIDEO' : URI + 'api/athlete/speedworkout/getathletevideo/',
    'FRONTEND_COACHED_ATHLETE_GET_ACTUAL_TIME' : URI + 'api/athlete/speedworkout/getathleteactualtime/',

    'FRONTEND_COACHED_ATHLETE_GET_PERFORMANCE_DATA' : URI + 'api/athlete/speedworkout/getperformancechart' ,
    'ADMIN_COACHED_ATHLETE_GET_PERFORMANCE_DATA' : URI + 'api/athlete/speedworkout/getadminperformancechart' ,

    'ADMIN_COACHED_ATHLETE_GET_DISTANCE_DATA' : URI + 'api/athlete/speedworkout/getadmindistancehistory' ,


    //STRENTG Workout Athlete Calls//
    'SAVE_ATHLETE_STRENGTHWORKOUT_WEEK': URI + 'api/athlete/strengthworkout/saveweekdata/',
    'GET_ATHLETE_STRENGTHWORKOUT_WEEKS': URI + 'api/athlete/strengthworkout/getweekdata/',
    'DELETE_ATHLETE_STRENGTHWORKOUT_WEEK': URI + 'api/athlete/strengthworkout/deleteweekdata',
    'SAVE_ATHLETE_STRENGTHWORKOUT_DATA': URI + 'api/athlete/strengthworkout/saveall',

    'FRONTEND_COACHED_ATHLETE_STRENGTH_WORKOUT' : URI + 'api/athlete/strengthworkout/getcoachedathletestrengthworkout/',
    


    //SAVE Athlete Notes
    'SAVE_ATHLETE_NOTES': URI + 'api/athlete/savenotes',

    /*STRENGTH TEMPLATE - PRODUCT CALLS */
    'ADMIN_CREATE_STRENGTH_PRODUCT' : URI + 'api/template_strength/product/createstrengthproduct',
    'ADMIN_MANAGE_STRENGTH_PRODUCT' : URI + 'api/template_strength/product/managestrengthproduct',
    'ADMIN_DELETE_STRENGTH_PRODUCT' : URI + 'api/template_strength/product/deletestrengthproduct/',
    'ADMIN_EDIT_STRENGTH_PRODUCT' : URI + 'api/template_strength/product/editstrengthproduct/',
    'ADMIN_GET_STRENGTH_PRODUCT' : URI + 'api/template_strength/product/getstrengthproduct/',
    'ADMIN_ADD_STRENGTH_EXERCISE' : URI + 'api/template_strength/product/addstrengthexercise/',
    'ADMIN_GET_STRENGTH_EXERCISE' : URI + 'api/template_strength/product/getstrengthexercise/',
    'ADMIN_DELETE_STRENGTH_EXERCISE' : URI + 'api/template_strength/product/deletestrengthexercise/',
    'ADMIN_SAVE_ALL_STRENGTH_EXERCISE' : URI + 'api/template_strength/product/saveallstrengthexercise/',
    //'ADMIN_UPDATE_STRENGTH_SUPERSET' : URI + 'api/template_strength/product/updatestrengthsuperset/',
    'ADMIN_DELETE_SUPERSET_EXERCISE' : URI + 'api/template_strength/product/deletesupersetexercise/',
    'ADMIN_DELETE_CIRCUIT_EXERCISE' : URI + 'api/template_strength/product/deletecircuitexercise/',

    'FRONTEND_STRENGTH_ALL_PRODUCTS' : URI + 'api/template_strength/product/getallstrengthproducts',
    'FRONTEND_STRENGTH_PRODUCT_DETAIL' : URI + 'api/template_strength/product/getstrengthproductdetail/',

    'FRONTEND_ATHLETE_PURCHASED_STRENGTH_PRODUCTS' : URI + 'api/template_strength/product/getathletepurchasedstrengthproducts/',
    'FRONTEND_ATHLETE_PURCHASED_STRENGTH_PRODUCT_DETAIL' : URI + 'api/template_strength/product/getathletepurchasedstrengthproductdetail/',





    /* Strength Training focus calls */
    'ADMIN_POST_STRENGTH_TEMPLATE_CREATE_TRAINING_FOCUS' : URI + 'api/template_strength/training_focus/createtrainingfocus',
    'ADMIN_STRENGTH_TEMPLATE_TRAINING_FOCUS_MANAGE' : URI + 'api/template_strength/training_focus/getalltrainingfocus',
    'ADMIN_DELETE_STRENGTH_TEMPLATE_TRAINING_FOCUS' : URI + 'api/template_strength/training_focus/deletetrainingfocus/',
    'ADMIN_GET_STRENGTH_TEMPLATE_TRAINING_FOCUS' : URI + 'api/template_strength/training_focus/gettrainingfocus/',
    'ADMIN_EDIT_STRENGTH_TEMPLATE_TRAINING_FOCUS' : URI + 'api/template_strength/training_focus/edittrainingfocus/',



    'POST_CREATE_ATHLETE': URI + 'api/athlete/register',
    'POST_ATHLETE_LOGIN': URI + 'api/athlete/login',
    'POST_CHECK_ATHLETE_EMAIL': URI + 'api/athlete/checkemail',
    'POST_ATHLETE_FORGOT_PASSWORD': URI + 'api/athlete/forgot-password',
    'GET_ATHLETE_BY_EMAIL': URI + 'api/athlete/email',
    'PATCH_ATHLETE_BY_EMAIL': URI + 'api/athlete/',
    'GET_ATHLETE_ALL': URI + 'api/athlete/',
    'DELETE_ATHLETE': URI + 'api/athlete/',
    'GET_ATHLETE_BY_ID': URI + 'api/athlete/',
    'GET_COACH_BY_ID': URI + 'api/coach/',

    'GET_ATHLETE_BY_ID_FRONT': URI + 'api/athlete/front',
    'UPDATE_ATHLETE_DETAILS_BY_ID_FRONT' : URI + 'api/athlete/front/editdetails/',

    'GET_COACH_BY_ID_FRONT': URI + 'api/coach/front',
    'UPDATE_COACH_DETAILS_BY_ID_FRONT' : URI + 'api/coach/front/editdetails/',

    'UPDATE_ATHLETE_DETAILS_BY_ID' : URI + 'api/athlete/editdetails/',
    'UPDATE_COACH_DETAILS_BY_ID' : URI + 'api/coach/editdetails/',

    'PROFILE_PICTURE_URL': URI,
    'SERVER_PICTURE_URL': URI,
    
    'POST_TOOLS_MYSPLIT': URI + 'api/tools/mysplit',

    'POST_CREATE_COACH': URI + 'api/coach/register',
    'POST_COACH_LOGIN': URI + 'api/coach/login',
    'POST_CHECK_COACH_EMAIL': URI + 'api/coach/checkemail',
    'POST_COACH_FORGOT_PASSWORD': URI + 'api/coach/forgot-password',
    'GET_COACH_BY_EMAIL': URI + 'api/coach/email',
    'PATCH_COACH_BY_EMAIL': URI + 'api/coach/',
    'GET_COACH_ALL': URI + 'api/coach/',
    'DELETE_COACH': URI + 'api/coach/',

    'POST_STAFF_LOGIN': URI + 'api/adminuser/login',
    'POST_STAFF_CREATE': URI + 'api/adminuser/create',
    'GET_STAFF_ALL': URI + 'api/adminuser/',
    'DELETE_STAFF': URI + 'api/adminuser/',
    'ADMIN_EDIT_STAFF' : URI + 'api/adminuser/editstaff/',

    'POST_CREATE_PHASE': URI + 'api/warmup_routine/phase/create',
    'GET_PHASE_ALL': URI + 'api/warmup_routine/phase/',
    'DELETE_PHASE': URI + 'api/warmup_routine/phase/',
    'UPDATE_PHASE_ORDER' : URI + 'api/warmup_routine/phase/reorder',
    'GET_PHASE_BY_ID': URI + 'api/warmup_routine/phase/',
    'PATCH_PHASE_BY_ID': URI + 'api/warmup_routine/phase/',
    'GET_PHASE_ALL_DATA': URI + 'api/warmup_routine/phase/all',


    'POST_STATIC_WARMUP_ROUTINE': URI + 'api/static/warmup_routine/create',
    'GET_STATIC_WARMUP_ROUTINES': URI + 'api/static/warmup_routine/',
    'GET_STATIC_WARMUP_ROUTINE_BY_ID' : URI + 'api/static/warmup_routine/',
    'EDIT_STATIC_WARMUP_ROUTINE': URI + 'api/static/warmup_routine/',
    'DELETE_STATIC_WARMUP_ROUTINE': URI + 'api/static/warmup_routine/',

    'GET_STATIC_WARMUP_ROUTINE_PHASES': URI + 'api/static/warmup_routine/phases/',
    'GET_COACH_STATIC_WARMUP_ROUTINE_PHASES': URI + 'api/static/warmup_routine/coach/phases/',


    'GET_STATIC_WARMUP_ROUTINE_PHASE_EXERCISES': URI + 'api/static/warmup_routine/phase-exercises/',
    'GET_COACH_STATIC_WARMUP_ROUTINE_PHASE_EXERCISES': URI + 'api/static/warmup_routine/coach/phase-exercises/',


    'GET_STATIC_WARMUP_ROUTINE_TEMPLATES': URI + 'api/static/warmup_routine/templates',
    'GET_STATIC_WARMUP_ROUTINES_TEMPLATES_LIST': URI + 'api/static/warmup_routine/alltemplates',

    //'POST_ATHLETE_WARMUP_ROUTINE': URI + 'api/athlete/warmup_routine/create',
    //'GET_ATHLETE_WARMUP_ROUTINE': URI + 'api/athlete/warmup_routine/',
    'GET_ATHLETE_WARMUP_ROUTINE_PHASES' : URI + 'api/athlete/warmup_routine/phases/',
    'GET_ATHLETE_WARMUP_ROUTINE_PHASE_EXERCISES': URI + 'api/athlete/warmup_routine/phase-exercises/',
    //'DELETE_ATHLETE_WARMUP_ROUTINE' : URI + 'api/athlete/warmup_routine/',
    'GET_ATHLETE_WARMUP_ROUTINE_BY_ID': URI + 'api/athlete/warmup_routine/byrecord/',
    'EDIT_ATHLETE_WARMUP_ROUTINE_BY_ID': URI + 'api/athlete/warmup_routine/savebyid/',
   

    'POST_CREATE_PHASE_EXERCISE': URI + 'api/warmup_routine/phase/exercise/create',
    'GET_PHASE_EXERCISE_ALL': URI + 'api/warmup_routine/phase/exercise/by_phase/',
    'GET_PHASE_EXERCISE': URI + 'api/warmup_routine/phase/exercise/',
    'UPDATE_PHASE_EXERCISE_ORDER' : URI + 'api/warmup_routine/phase/exercise/reorder/',
    'DELETE_PHASE_EXERCISE': URI + 'api/warmup_routine/phase/exercise/',
    'PATCH_PHASE_EXERCISE_BY_ID': URI + 'api/warmup_routine/phase/exercise/',
    'GET_PHASE_EXERCISE_ALL_DATA': URI + 'api/warmup_routine/phase/exercise/all',


    'POST_SAVE_STATIC_WORKOUT_TEMPLATE': URI + 'api/static_workout_template/create',
    'EDIT_STATIC_WORKOUT_TEMPLATE': URI + 'api/static_workout_template/',
    'DELETE_STATIC_WORKOUT_TEMPLATE': URI + 'api/static_workout_template/',
    'GET_STATIC_WORKOUT_TEMPLATE': URI + 'api/static_workout_template/',
    'MANAGE_STATIC_WORKOUT_TEMPLATES': URI + 'api/static_workout_template/manage',
    
    'GET_STATIC_WORKOUT_TEMPLATES_FRONT': URI + 'api/static_workout_template/',
    'GET_COACH_STATIC_WORKOUT_TEMPLATES_FRONT': URI + 'api/static_workout_template/coach/',


    'GET_STATIC_WORKOUT_TEMPLATES_FRONT_ATHLETE_PURCHASED': URI + 'api/static_workout_template/getallpurchasedtemplates/',

    'GET_STATIC_WORKOUT_TEMPLATE_FRONT_BY_ID': URI + 'api/static_workout_template/details/',
    'GET_COACH_STATIC_WORKOUT_TEMPLATE_FRONT_BY_ID': URI + 'api/static_workout_template/coach/details/',
    

    'GET_STATIC_WORKOUT_TEMPLATES_FRONT_COACH_PURCHASED': URI + 'api/static_workout_template/getallcoachpurchasedtemplates/',

    'POST_SAVE_STATIC_WORKOUT': URI + 'api/static_workout/create',
    'GET_STATIC_WORKOUT': URI + 'api/static_workout/manage/',
    'GET_STATIC_WORKOUT_BY_THEME': URI + 'api/static_workout/',
    'POST_SAVE_STATIC_WORKOUT_BY_THEME': URI + 'api/static_workout/savebytheme',
    'DELETE_STATIC_WORKOUT_BY_THEME' : URI + 'api/static_workout/deletebytheme',

    'GET_ATHLETE_STATIC_WORKOUT_WEEKS_DAYS' : URI + 'api/static_workout/athlete/getweeksdays/', 
    'GET_COACH_STATIC_WORKOUT_WEEKS_DAYS' : URI + 'api/static_workout/coach/getweeksdays/', 

    'GET_ATHLETE_STATIC_WORKOUT_SPRINTS_BY_THEME' : URI + 'api/static_workout/athlete/getsprints/', 
    'GET_COACH_STATIC_WORKOUT_SPRINTS_BY_THEME' : URI + 'api/static_workout/coach/getsprints/', 

    'POST_SAVE_ATHLETE_DYNAMIC_WORKOUT': URI + 'api/athlete_dynamic_workout/create',
    'GET_ATHLETE_DYNAMIC_WORKOUT': URI + 'api/athlete_dynamic_workout/manage/',
    'GET_ATHLETE_DYNAMIC_WORKOUT_BY_THEME': URI + 'api/athlete_dynamic_workout/',
    'POST_SAVE_ATHLETE_WORKOUT_BY_THEME': URI + 'api/athlete_dynamic_workout/savebytheme/',
    'DELETE_ATHLETE_WORKOUT_BY_THEME' : URI + 'api/athlete_dynamic_workout/deletebytheme/',
    'GET_ATHLETE_DYNAMIC_WORKOUT_THEMES_BY_DATE': URI + 'api/athlete_dynamic_workout/getthemebydate/',
    'GET_ATHLETE_DYNAMIC_WORKOUT_SPRINTS_BY_THEME': URI + 'api/athlete_dynamic_workout/getallsprintsbytheme/',
    'POST_ATHLETE_ACTUAL_TIME_BY_SPRINT': URI + 'api/athlete_dynamic_workout/updateactualtime/',
    'POST_ATHLETE_VIDEO_BY_SPRINT': URI + 'api/athlete_dynamic_workout/updatevideo/',
    
    'POST_CREATE_STRENGTH_EXERCISE': URI + 'api/strength_training/exercise/create',
    'GET_STRENGTH_EXERCISE_ALL' : URI + 'api/strength_training/exercise/manage',
    'UPDATE_STRENGTH_EXERCISE' : URI + 'api/strength_training/exercise/update/',
    'GET_STRENGTH_EXERCISE' : URI + 'api/strength_training/exercise/get/',
    'DELETE_STRENGTH_EXERCISE' : URI + 'api/strength_training/exercise/delete/',
    'SELECT_STRENGTH_EXERCISE_ALL' : URI + 'api/strength_training/exercise/getall',

    'MANAGE_STATIC_STRENGTH_TEMPLATES': URI + 'api/strength_training/static_strength/template/manage',
    'DELETE_STATIC_STRENGTH_WORKOUT_TEMPLATE': URI + 'api/strength_training/static_strength/template/',
    'POST_STATIC_STRENGTH_WORKOUT_TEMPLATE': URI + 'api/strength_training/static_strength/template/create',
    'GET_STATIC_STRENGTH_WORKOUT_TEMPLATE': URI + 'api/strength_training/static_strength/template/',
    'EDIT_STATIC_STRENGTH_WORKOUT_TEMPLATE': URI + 'api/strength_training/static_strength/template/',

    'GET_STATIC_STRENGTH_WORKOUT_TEMPLATES_FRONT' : URI + 'api/strength_training/static_strength/template/',
    'GET_COACH_STATIC_STRENGTH_WORKOUT_TEMPLATES_FRONT' : URI + 'api/strength_training/static_strength/template/coach/',

    'GET_STATIC_STRENGTH_WORKOUT_TEMPLATES_FRONT_ATHLETE_PURCHASED' : URI + 'api/strength_training/static_strength/template/getallpurchasedtemplates/',
    'GET_STATIC_STRENGTH_WORKOUT_TEMPLATES_FRONT_COACH_PURCHASED' : URI + 'api/strength_training/static_strength/template/getallcoachpurchasedtemplates/',


    'GET_STATIC_STRENGTH_TEMPLATE_FRONT_BY_ID' : URI + 'api/strength_training/static_strength/template/details/',
    'GET_COACH_STATIC_STRENGTH_TEMPLATE_FRONT_BY_ID' : URI + 'api/strength_training/static_strength/template/coach/details/',

    'POST_STATIC_STRENGTH_WORKOUT_EXERCISE': URI + 'api/strength_training/static_strength/createexercise/',
    'EDIT_STATIC_STRENGTH_WORKOUT_EXERISE': URI + 'api/strength_training/static_strength/editexercise/',
    'POST_STATIC_STRENGTH_WORKOUT_SUPERSET': URI + 'api/strength_training/static_strength/createsuperset/',
    'POST_STATIC_STRENGTH_WORKOUT_CIRCUIT': URI + 'api/strength_training/static_strength/createcircuit/',
    'GET_STATIC_STRENGTH_WORKOUT_BY_TEMPLATE': URI + 'api/strength_training/static_strength/getalltemplatedata/',

    'GET_ATHLETE_STATIC_STRENGTH_WORKOUT_WEEKS_DAYS' :  URI + 'api/strength_training/static_strength/gettemplateweeksdays/',
    'GET_COACH_STATIC_STRENGTH_WORKOUT_WEEKS_DAYS' :  URI + 'api/strength_training/static_strength/coach/gettemplateweeksdays/',

    'GET_ATHLETE_STATIC_STRENGTH_WORKOUT_LIST_BY_DAY': URI + 'api/strength_training/static_strength/getworkoutbyday/',
    'GET_COACH_STATIC_STRENGTH_WORKOUT_LIST_BY_DAY': URI + 'api/strength_training/static_strength/coach/getworkoutbyday/',

    'GET_ATHLETE_STATIC_STRENGTH_WORKOUT_BY_ID' : URI + 'api/strength_training/static_strength/getworkoutbyid/',
    'GET_COACH_STATIC_STRENGTH_WORKOUT_BY_ID' : URI + 'api/strength_training/static_strength/coach/getworkoutbyid/',

    'POST_STATIC_STRENGTH_WORKOUT_DAY_ORDER': URI + 'api/strength_training/static_strength/updatedayitemsorder/',
    'DELETE_STATIC_STRENGTH_DAY_BLOCK_BY_ID': URI + 'api/strength_training/static_strength/deletedayblock/',
    'GET_STATIC_STRENGTH_WORKOUT_EXERCISE': URI + 'api/strength_training/static_strength/getexercisedetails/',
    'GET_STATIC_STRENGTH_WORKOUT_SUPERSET' : URI + 'api/strength_training/static_strength/getsupersetdetails/',
    'GET_STATIC_STRENGTH_WORKOUT_CIRCUIT' : URI + 'api/strength_training/static_strength/getcircuitdetails/',
    'EDIT_STATIC_STRENGTH_WORKOUT_SUPERSET' : URI + 'api/strength_training/static_strength/editsuperset/',
    'EDIT_STATIC_STRENGTH_WORKOUT_CIRCUIT': URI + 'api/strength_training/static_strength/editcircuit/',

   

    'POST_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_EXERCISE' : URI + 'api/strength_training/athlete_dynamic_strength/saveexercise/',
    'GET_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_EXERCISE' : URI + 'api/strength_training/athlete_dynamic_strength/getexercisedetails/',
    'EDIT_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_EXERISE': URI + 'api/strength_training/athlete_dynamic_strength/editexercise/',

    'POST_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_SUPERSET' : URI + 'api/strength_training/athlete_dynamic_strength/savesuperset/',
    'GET_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_SUPERSET' : URI + 'api/strength_training/athlete_dynamic_strength/getsupersetdetails/',
    'EDIT_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_SUPERSET': URI + 'api/strength_training/athlete_dynamic_strength/editsuperset/',

    'POST_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_CIRCUIT' : URI + 'api/strength_training/athlete_dynamic_strength/savecircuit/',
    'GET_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_CIRCUIT' : URI + 'api/strength_training/athlete_dynamic_strength/getcircuitdetails/',
    'EDIT_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_CIRCUIT': URI + 'api/strength_training/athlete_dynamic_strength/editcircuit/',


    'GET_DYNAMIC_STRENGTH_WORKOUT_BY_ATHLETE': URI + 'api/strength_training/athlete_dynamic_strength/getallworkoutbydate/',
    'POST_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_DATE_ORDER' : URI + 'api/strength_training/athlete_dynamic_strength/updatedateitemsorder/',
    'DELETE_ATHLETE_DYNAMIC_STRENGTH_DATE_BLOCK_BY_ID': URI + 'api/strength_training/athlete_dynamic_strength/deletedateblock/',
    'GET_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_LIST_BY_DATE' : URI + 'api/strength_training/athlete_dynamic_strength/getworkoutbydate/',
    'GET_ATHLETE_DYNAMIC_STRENGTH_WORKOUT_BY_ID' : URI + 'api/strength_training/athlete_dynamic_strength/getworkoutbyid/',

    'SEND_ATHLETE_MESSAGE_TO_AMAX': URI + 'api/athlete/message/sendstaff',
    'SEND_AMAX_MESSAGE_TO_ATHLETE': URI + 'api/athlete/message/sendathlete',

    'DELETE_ATHLETE_MESSAGE': URI + 'api/athlete/message/',
    'GET_ATHLETE_MESSAGE': URI + 'api/athlete/message',
    'GET_AMAX_REPLIES_TO_MESSAGE': URI + 'api/athlete/message/replies',
    'GET_ATHLETE_UNREAD_MESSAGE_COUNT': URI + 'api/athlete/message/notification/',
    'GET_AMAX_REPLIES_TO_ATHLETE': URI + 'api/athlete/message/amaxreplies/',
    'DELETE_ATHLETE_AMAX_REPLY': URI + 'api/athlete/message/deletereply/',
   
    'DELETE_ATTACHMENT' : URI + 'api/athlete/message/deleteattachment/',

    'ADMIN_MANAGE_ATHLETE_MESSAGES': URI + 'api/athlete/message/all',
    'ADMIN_GET_ATHLETE_ALL_MESSAGES' : URI + 'api/athlete/message/getAthleteAllAdmin/',
    'FRONTEND_ATHLETE_GET_ALL_MESSAGES' : URI + 'api/athlete/message/getAthleteAll/',
    'FRONTEND_ATHLETE_DELETE_MESSAGE' : URI + 'api/athlete/message/deletemessage/',
    'FRONTEND_ATHLETE_MARK_MESSAGE_AS_READ' : URI + 'api/athlete/message/markasread/',


    'SEND_COACH_MESSAGE_TO_AMAX': URI + 'api/coach/message/sendstaff',
    'SEND_AMAX_MESSAGE_TO_COACH': URI + 'api/coach/message/sendcoach',
    'MANAGE_COACH_MESSAGES': URI + 'api/coach/message/all',
    'DELETE_COACH_MESSAGE': URI + 'api/coach/message/',
    'GET_COACH_MESSAGE': URI + 'api/coach/message',
    'GET_COACH_AMAX_REPLIES_TO_MESSAGE': URI + 'api/coach/message/replies',
    'GET_COACH_UNREAD_MESSAGE_COUNT': URI + 'api/coach/message/notification/',
    'GET_AMAX_REPLIES_TO_COACH': URI + 'api/coach/message/amaxreplies/',
    'DELETE_COACH_AMAX_REPLY': URI + 'api/coach/message/deletereply/',


    'POST_ATHLETE_PURCHASE_SPEED_DATA': URI + 'api/athlete/purchase/savespeedtemplate/',
    'POST_ATHLETE_PURCHASE_STRENGTH_DATA': URI + 'api/athlete/purchase/savestrengthtemplate/',
    'GET_ATHLETE_PURCHASE_DATA': URI + 'api/athlete/purchase/getpurchasedata/',
    'GET_ATHLETE_PURCHASE_DATA_ADMIN': URI + 'api/athlete/purchase/getpurchasedataadmin/',
    'POST_ATHLETE_PURCHASE_TOOL_DATA': URI + 'api/athlete/purchase/savetool/',
     'CREATE_PAYMENT_INTENT' : URI + 'api/athlete/purchase/createpaymentintent',

     'ADMIN_ASSIGN_PRODUCT_TO_ATHLETE' : URI + 'api/athlete/purchase/assignproducttoathlete/' ,




    'POST_COACH_PURCHASE_SPEED_DATA': URI + 'api/coach/purchase/savespeedtemplate/',
    'POST_COACH_PURCHASE_STRENGTH_DATA': URI + 'api/coach/purchase/savestrengthtemplate/',
    'GET_COACH_PURCHASE_DATA': URI + 'api/coach/purchase/getpurchasedata/',
    'GET_COACH_PURCHASE_DATA_ADMIN': URI + 'api/coach/purchase/getpurchasedataadmin/',
    'POST_COACH_PURCHASE_TOOL_DATA': URI + 'api/coach/purchase/savetool/',

    'POST_ATHLETE_RUNROCKET_TEST_RESULT': URI + 'api/athlete/runrocket/savetestresults/',
    'DELETE_ATHLETE_RUNROCKET_TEST_RESULT': URI + 'api/athlete/runrocket/deletetestresults/',
    'GET_ATHLETE_RUNROCKET_ADMIN_TEST_RESULT': URI + 'api/athlete/runrocket/admintestresults/',

    'POST_COACH_RUNROCKET_TEST_RESULT': URI + 'api/coach/runrocket/savetestresults/',
    'DELETE_COACH_RUNROCKET_TEST_RESULT': URI + 'api/coach/runrocket/deletetestresults/',
    'GET_COACH_RUNROCKET_ADMIN_TEST_RESULT': URI + 'api/coach/runrocket/admintestresults/',
    
    
    'GET_ATHLETE_RUNROCKET_TEST_RESULT': URI + 'api/athlete/runrocket/athletetestresults/',
    'GET_COACH_RUNROCKET_TEST_RESULT': URI + 'api/coach/runrocket/coachtestresults/',


    'POST_ATHLETE_RUNROCKET_TRAINING_DAY_SET_MAXSPEED': URI + 'api/athlete/runrocket/savemaxspeedforaset/',
    'GET_ATHLETE_RUNROCKET_TRAINING_DAY_MAXSPEEDS': URI + 'api/athlete/runrocket/getallmaxspeedsforday/',
    'GET_ATHLETE_RUNROCKET_PERFORMANCE': URI + 'api/athlete/runrocket/getperformancedata/',
    'GET_ADMIN_ATHLETE_RUNROCKET_PERFORMANCE': URI + 'api/athlete/runrocket/getperformancedataadmin/',

    'POST_COACH_RUNROCKET_TRAINING_DAY_SET_MAXSPEED': URI + 'api/coach/runrocket/savemaxspeedforaset/',
    'GET_COACH_RUNROCKET_TRAINING_DAY_MAXSPEEDS': URI + 'api/coach/runrocket/getallmaxspeedsforday/',
    'GET_COACH_RUNROCKET_PERFORMANCE': URI + 'api/coach/runrocket/getperformancedata/',
    
    'ADMIN_ASSIGN_AST_SPEED_TOOL_TO_ATHLETE' : URI + 'api/athlete/runrocket/assignASTspeedtoathlete/' ,

    'MANAGE_RUNROCKET_TRAINING_TEMPLATES': URI + 'api/runrocket/templates/manage',
    'POST_RUNROCKET_TRAINING_TEMPLATE_DATA': URI + 'api/runrocket/templates/saveset/',
    'GET_RUNROCKET_TRAINING_TEMPLATE_DATA': URI + 'api/runrocket/templates/gettraining/',
    'DELETE_RUNROCKET_TRAINING_TEMPLATE_SET': URI + 'api/runrocket/templates/deleteset/',
    'EDIT_RUNROCKET_TRAINING_TEMPLATE_SET': URI + 'api/runrocket/templates/editset/',
    'GET_RUNROCKET_TRAINING_TEMPLATE_SET' : URI + 'api/runrocket/templates/getset/',
    'ADMIN_EDIT_RUNROCKET_DAY_FOCUS' : URI + 'api/runrocket/templates/editdayfocus/', //edit the days focus in admin






    'GET_RUNROCKET_TRAINING_TEMPLATE_FRONT_WEEKS': URI + 'api/runrocket/templates/gettrainingfrontend/',
    'GET_COACH_RUNROCKET_TRAINING_TEMPLATE_FRONT_WEEKS': URI + 'api/runrocket/templates/coach/gettrainingfrontend/',
    

    'GET_RUNROCKET_TRAINING_TEMPLATE_DAY_SETS': URI + 'api/runrocket/templates/getdaysets/',
    'GET_COACH_RUNROCKET_TRAINING_TEMPLATE_DAY_SETS': URI + 'api/runrocket/templates/coach/getdaysets/',


    'POST_ATHLETE_LOADVELOCITY_TEST_RESULT': URI + 'api/athlete/loadvelocity/savetestresults/',
    'DELETE_ATHLETE_LOADVELOCITY_TEST_RESULT': URI + 'api/athlete/loadvelocity/deletetestresults/',
    'GET_ATHLETE_LOADVELOCITY_ADMIN_TEST_RESULT': URI + 'api/athlete/loadvelocity/admintestresults/',

    'POST_COACH_LOADVELOCITY_TEST_RESULT': URI + 'api/coach/loadvelocity/savetestresults/',
    'DELETE_COACH_LOADVELOCITY_TEST_RESULT': URI + 'api/coach/loadvelocity/deletetestresults/',
    'GET_COACH_LOADVELOCITY_ADMIN_TEST_RESULT': URI + 'api/coach/loadvelocity/admintestresults/',

    'GET_ATHLETE_LOADVELOCITY_TEST_RESULT': URI + 'api/athlete/loadvelocity/athletetestresults/',
    'GET_COACH_LOADVELOCITY_TEST_RESULT': URI + 'api/coach/loadvelocity/coachtestresults/',
  

    'POST_ATHLETE_LOADVELOCITY_TRAINING_DAY_SET_MAXSPEED': URI + 'api/athlete/loadvelocity/savemaxspeedforaset/',
    'GET_ATHLETE_LOADVELOCITY_TRAINING_DAY_MAXSPEEDS': URI + 'api/athlete/loadvelocity/getallmaxspeedsforday/',
    'GET_ATHLETE_LOADVELOCITY_PERFORMANCE': URI + 'api/athlete/loadvelocity/getperformancedata/',
    'GET_ADMIN_ATHLETE_LOADVELOCITY_PERFORMANCE': URI + 'api/athlete/loadvelocity/getperformancedataadmin/',

    'POST_COACH_LOADVELOCITY_TRAINING_DAY_SET_MAXSPEED': URI + 'api/coach/loadvelocity/savemaxspeedforaset/',
    'GET_COACH_LOADVELOCITY_TRAINING_DAY_MAXSPEEDS': URI + 'api/coach/loadvelocity/getallmaxspeedsforday/',
    'GET_COACH_LOADVELOCITY_PERFORMANCE': URI + 'api/coach/loadvelocity/getperformancedata/',

    'MANAGE_LOADVELOCITY_TRAINING_TEMPLATES': URI + 'api/loadvelocity/templates/manage',
    'POST_LOADVELOCITY_TRAINING_TEMPLATE_DATA': URI + 'api/loadvelocity/templates/saveset/',
    'GET_LOADVELOCITY_TRAINING_TEMPLATE_DATA': URI + 'api/loadvelocity/templates/gettraining/',
    'DELETE_LOADVELOCITY_TRAINING_TEMPLATE_SET': URI + 'api/loadvelocity/templates/deleteset/',
    'EDIT_LOADVELOCITY_TRAINING_TEMPLATE_SET': URI + 'api/loadvelocity/templates/editset/',
    'GET_LOADVELOCITY_TRAINING_TEMPLATE_SET' : URI + 'api/loadvelocity/templates/getset/',

    'GET_LOADVELOCITY_TRAINING_TEMPLATE_FRONT_WEEKS': URI + 'api/loadvelocity/templates/gettrainingfrontend/',
    'GET_COACH_LOADVELOCITY_TRAINING_TEMPLATE_FRONT_WEEKS': URI + 'api/loadvelocity/templates/coach/gettrainingfrontend/',

    'GET_LOADVELOCITY_TRAINING_TEMPLATE_DAY_SETS': URI + 'api/loadvelocity/templates/getdaysets/',
    'GET_COACH_LOADVELOCITY_TRAINING_TEMPLATE_DAY_SETS': URI + 'api/loadvelocity/templates/coach/getdaysets/',


}

Object.freeze(API_URL);

export default API_URL;
